/**
 * @generated SignedSource<<77477f07599f54526beb5d2b4b25f829>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CalendarTeamEventItem_event$data = {
  readonly storeCalendar: {
    readonly color: string;
  };
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"CalendarOverviewEventItemDateTime_event">;
  readonly " $fragmentType": "CalendarTeamEventItem_event";
};
export type CalendarTeamEventItem_event$key = {
  readonly " $data"?: CalendarTeamEventItem_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"CalendarTeamEventItem_event">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CalendarTeamEventItem_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreCalendar",
      "kind": "LinkedField",
      "name": "storeCalendar",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "color",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CalendarOverviewEventItemDateTime_event"
    }
  ],
  "type": "CalendarEvent",
  "abstractKey": null
};

(node as any).hash = "865671fda722b4b484e3a7c6a0312e9b";

export default node;
